// extracted by mini-css-extract-plugin
export default {"badge":"EmailStatusBadge_badge__ilVpO","success":"EmailStatusBadge_success__IK+YU","warning":"EmailStatusBadge_warning__TXRih"};